if (!customElements.get('home-scene-detail')) {
  class HomeSceneDetail extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.tabs = this.querySelectorAll('.home-scene-tab-item')
      this.scenes = this.querySelectorAll('.home-scene-block')

      this.initTabs()
      this.initHotspots()
    }

    initTabs() {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const targetIndex = tab.dataset.target

          // Update Tabs
          this.tabs.forEach(t => t.classList.remove('active'))
          tab.classList.add('active')

          // Update Scenes
          this.scenes.forEach(s => s.classList.remove('active'))
          const activeScene = this.querySelector(`.home-scene-block[data-index="${targetIndex}"]`)
          if (activeScene) {
            activeScene.classList.add('active')
            this.resetScene(activeScene)
          }
        })
      })
    }

    initHotspots() {
      this.scenes.forEach(scene => {
        const hotspots = scene.querySelectorAll('.home-scene-hotspot')
        const mobileCards = scene.querySelectorAll('.home-scene-mobile-product-card')

        hotspots.forEach(hotspot => {
          hotspot.addEventListener('click', () => {
            const isActive = hotspot.classList.contains('active')

            // Deactivate others in same scene
            hotspots.forEach(h => h.classList.remove('active'))

            // Toggle current hotspot: if active, close it; otherwise, activate it
            if (!isActive) {
              hotspot.classList.add('active')

              // Mobile: Show corresponding card
              const index = hotspot.dataset.productIndex
              mobileCards.forEach(c => c.classList.remove('active'))
              const targetCard = scene.querySelector(`.home-scene-mobile-product-card[data-product-index="${index}"]`)
              if (targetCard) targetCard.classList.add('active')
            } else {
              // Mobile: Hide all cards when closing hotspot
              mobileCards.forEach(c => c.classList.remove('active'))
            }
          })
        })
      })
    }

    resetScene(scene) {
      const hotspots = scene.querySelectorAll('.home-scene-hotspot')
      const mobileCards = scene.querySelectorAll('.home-scene-mobile-product-card')

      hotspots.forEach(h => h.classList.remove('active'))
      mobileCards.forEach(c => c.classList.remove('active'))

      if (hotspots.length > 0) {
        hotspots[0].classList.add('active')
        const index = hotspots[0].dataset.productIndex
        const targetCard = scene.querySelector(`.home-scene-mobile-product-card[data-product-index="${index}"]`)
        if (targetCard) targetCard.classList.add('active')
      }
    }
  }

  customElements.define('home-scene-detail', HomeSceneDetail)
}
